// src/components/network/ForfeoPartnerPayoutReadiness.tsx
import React from 'react';
import { FaCheckCircle, FaClock, FaFileContract, FaMoneyBillWave, FaQrcode, FaShieldAlt, FaWallet } from 'react-icons/fa';

type Props = {
  title?: string;
  subtitle?: string;
  compact?: boolean;
};

const items = [
  { icon: <FaWallet />, label: 'Forfeo encaisse', text: 'Le paiement client est centralisé avant le règlement partenaire.' },
  { icon: <FaQrcode />, label: 'Validation QR', text: 'Le pass ou voucher confirme l’utilisation réelle de l’expérience.' },
  { icon: <FaClock />, label: 'Paiement à venir', text: 'Le montant net partenaire peut être préparé après validation.' },
  { icon: <FaFileContract />, label: 'Trace contractuelle', text: 'Les règles de commission, remboursement et litige restent documentées.' },
];

export default function ForfeoPartnerPayoutReadiness({
  title = 'Préparation paiements partenaires',
  subtitle = 'Forfeo Network prépare le modèle : client payé, expérience validée, montant partenaire calculé et suivi opérationnel.',
  compact = false,
}: Props) {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-emerald-100 bg-gradient-to-br from-white via-emerald-50/60 to-blue-50 p-5 shadow-sm md:p-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div className="max-w-3xl">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-white/80 px-3 py-1.5 text-[10px] font-black uppercase tracking-[0.22em] text-emerald-700">
            <FaShieldAlt /> Forfeo Network
          </div>
          <h3 className="text-2xl font-black tracking-tight text-slate-950 md:text-3xl">{title}</h3>
          <p className="mt-2 text-sm font-medium leading-6 text-slate-600">{subtitle}</p>
        </div>
        <div className="rounded-3xl bg-slate-950 px-5 py-4 text-white shadow-xl">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-400 text-slate-950"><FaMoneyBillWave /></div>
            <div>
              <p className="text-[10px] font-black uppercase tracking-widest text-emerald-200">Mode pilote</p>
              <p className="text-sm font-black">Calcul avant automatisation Stripe Connect</p>
            </div>
          </div>
        </div>
      </div>
      {!compact && (
        <div className="mt-5 grid gap-3 md:grid-cols-2 xl:grid-cols-4">
          {items.map((item) => (
            <div key={item.label} className="rounded-3xl border border-white/80 bg-white/80 p-4 shadow-sm">
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-700">{item.icon}</div>
              <p className="text-sm font-black text-slate-950">{item.label}</p>
              <p className="mt-1 text-xs font-medium leading-5 text-slate-500">{item.text}</p>
            </div>
          ))}
        </div>
      )}
      <div className="mt-4 flex flex-wrap gap-2 text-[11px] font-black uppercase tracking-widest text-slate-500">
        <span className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1.5"><FaCheckCircle className="text-emerald-500" /> Aucun paiement réel modifié</span>
        <span className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1.5"><FaCheckCircle className="text-emerald-500" /> Supabase intact</span>
        <span className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1.5"><FaCheckCircle className="text-emerald-500" /> Préparation Forfeo Network</span>
      </div>
    </section>
  );
}
